import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListaJefes = () => {
  const [jefes, setJefes] = useState([]);
  const navigate = useNavigate();

  // Función para obtener los datos
  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get('/api/jefe/listall/');
      const jefesConFunciones = data.jefes.map((jefe) => ({
        ...jefe,
        funciones: (
          <div className="d-flex gap-2">
            <button
              className="btn btn-warning"
              style={{ width: 30, height: 30, padding: 0 }}
              onClick={() => navigate(`/enteconformador/jefes/${jefe._id}`)}
              title="Editar Asociaciones"
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>

            <button
              className="btn btn-danger"
              style={{ width: 30, height: 30, padding: 0 }}
              onClick={() => deleteJefe(jefe._id)}
              title="Eliminar"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </div>
        ),
      }));
      setJefes(jefesConFunciones);
    } catch (error) {
      console.error('Error al cargar los jefes:', error.message);
    }
    // eslint-disable-next-line 
  }, []);

  // Ejecutar getData cuando el componente se monte
  useEffect(() => {
    getData();
  }, [getData]);

  // Función para eliminar un instructor
  const deleteJefe = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/jefe/${id}`);
          getData(); // Refrescar los datos
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el jefe:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el jefe.', 'error');
    }
  };




  const columns = React.useMemo(() => [
    { Header: 'Documento', accessor: 'documentoJefe' },
    { Header: 'Nombre', accessor: 'nombre1Jefe' },
    { Header: 'Apellido', accessor: 'apellido1Jefe' },
    { Header: 'Telefono', accessor: 'telefono1Jefe' },
    { Header: 'Email', accessor: 'emailJefe' },
    { accessor: 'funciones' },
  ], []);

  return (
  <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Jefes</h1>

      {Array.isArray(jefes) && jefes.length > 0 ? (
        <DataTable columns={columns} data={jefes} />
      ) : (
        <p>Cargando jefes...</p>
      )}

    </div>
  );
};

export default ListaJefes;
